import RbvDialogService from 'root/v-components/_core/rbv-dialog/RbvDialogService';
import RbvNotificationService from 'root/v-components/_core/rbv-notifications/RbvNotificationService';

export const Notification = new RbvNotificationService();
export const Dialog = new RbvDialogService()
